module.exports = __webpack_public_path__ + "static/media/Logo_Standby_Large.49db40ac.png";